<button
  (click)="onAddProvider()"
  type="button"
  [disabled]="(1 | isReadonlyRole) || !(isSettingsLoaded$ | async)"
  [ngClass]="btnClass"
>
  <span class="cs-icon cs-icon-link-plus" aria-hidden="true"></span>
  {{ label }}
</button>
